var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_9889357",
    clipPath: "url(#clip0_0_3594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1437110010432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_337571344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.616 33.4954H2.38477C2.12617 33.4954 1.91602 33.286 1.91602 33.0266V8.43364C1.91602 7.6188 2.5793 6.9563 3.39336 6.9563H8.05977C8.31836 6.9563 8.52852 7.16646 8.52852 7.42505C8.52852 7.68364 8.31836 7.8938 8.05977 7.8938H3.39336C3.0957 7.8938 2.85352 8.13599 2.85352 8.43364V32.5579H38.1473V8.43364C38.1473 8.13599 37.9051 7.8938 37.6074 7.8938H32.941C32.6824 7.8938 32.4723 7.68364 32.4723 7.42505C32.4723 7.16646 32.6824 6.9563 32.941 6.9563H37.6074C38.4215 6.9563 39.0848 7.6188 39.0848 8.43364V33.0266C39.0848 33.286 38.8746 33.4954 38.616 33.4954Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337571080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2723 31.1516H4.72852C4.46992 31.1516 4.25977 30.9422 4.25977 30.6829V9.7688C4.25977 9.50942 4.46992 9.30005 4.72852 9.30005H8.05977C8.31836 9.30005 8.52852 9.50942 8.52852 9.7688C8.52852 10.0274 8.31836 10.2375 8.05977 10.2375H5.19727V30.2141H35.8035V10.2375H32.941C32.6824 10.2375 32.4723 10.0274 32.4723 9.7688C32.4723 9.50942 32.6824 9.30005 32.941 9.30005H36.2723C36.5309 9.30005 36.741 9.50942 36.741 9.7688V30.6829C36.741 30.9422 36.5309 31.1516 36.2723 31.1516Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337571848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7641 37.7625H5.23594C2.62422 37.7625 0.5 35.6383 0.5 33.0274C0.5 32.8883 0.560156 32.7641 0.655469 32.679C0.738281 32.604 0.848437 32.5579 0.96875 32.5579H0.969531C0.973438 32.5579 0.977344 32.5579 0.982031 32.5586L40.0312 32.5579C40.1555 32.5579 40.275 32.6079 40.3625 32.6954C40.4508 32.7836 40.5 32.9024 40.5 33.0266C40.5 35.6383 38.3758 37.7625 35.7641 37.7625ZM1.46641 33.4954C1.69766 35.3696 3.3 36.825 5.23594 36.825H35.7641C37.7 36.825 39.3023 35.3696 39.5336 33.4961L1.46641 33.4954Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337572040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9133 35.5125H17.0859C16.2719 35.5125 15.6094 34.85 15.6094 34.0352V33.0266C15.6094 32.768 15.8188 32.5579 16.0781 32.5579H24.9219C25.1813 32.5579 25.3906 32.768 25.3906 33.0266V34.0352C25.3906 34.85 24.7281 35.5125 23.9133 35.5125ZM16.5469 33.4954V34.0352C16.5469 34.3329 16.7891 34.575 17.0859 34.575H23.9133C24.2109 34.575 24.4531 34.3329 24.4531 34.0352V33.4954H16.5469Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337571872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5738 35.6292H32.5645C32.3059 35.6292 32.0957 35.4198 32.0957 35.1604C32.0957 34.9018 32.3059 34.6917 32.5645 34.6917H33.5738C33.8324 34.6917 34.0426 34.9018 34.0426 35.1604C34.0426 35.4198 33.8324 35.6292 33.5738 35.6292Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337572304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9781 35.6289H34.9695C34.7109 35.6289 34.5007 35.4195 34.5007 35.1602C34.5007 34.9016 34.7109 34.6914 34.9695 34.6914H35.9781C36.2367 34.6914 36.4468 34.9016 36.4468 35.1602C36.4468 35.4195 36.2375 35.6289 35.9781 35.6289Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337572256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9406 28.5704H8.05933C7.79995 28.5704 7.59058 28.3602 7.59058 28.1016V2.7063C7.59058 2.44771 7.79995 2.23755 8.05933 2.23755H32.9406C33.1992 2.23755 33.4093 2.44771 33.4093 2.7063V28.1016C33.4093 28.3602 33.1999 28.5704 32.9406 28.5704ZM8.52808 27.6329H32.4718V3.17505H8.52808V27.6329Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337572136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9406 8.73755H8.05933C7.79995 8.73755 7.59058 8.52739 7.59058 8.2688V2.7063C7.59058 2.44692 7.79995 2.23755 8.05933 2.23755H32.9406C33.1999 2.23755 33.4093 2.44692 33.4093 2.7063V8.2688C33.4093 8.52739 33.1999 8.73755 32.9406 8.73755ZM8.52808 7.80005H32.4718V3.17505H8.52808V7.80005Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337572544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4895 7.1064H9.85742C9.59883 7.1064 9.38867 6.89624 9.38867 6.63765V4.33765C9.38867 4.07905 9.59883 3.8689 9.85742 3.8689H12.4895C12.748 3.8689 12.9582 4.07905 12.9582 4.33765V6.63765C12.9582 6.89624 12.748 7.1064 12.4895 7.1064ZM10.3262 6.1689H12.0207V4.8064H10.3262V6.1689Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337571968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1422 5.9563H24.6555C24.3969 5.9563 24.1868 5.74614 24.1868 5.48755C24.1868 5.22896 24.3969 5.0188 24.6555 5.0188H31.1422C31.4008 5.0188 31.611 5.22896 31.611 5.48755C31.611 5.74614 31.4008 5.9563 31.1422 5.9563Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337571944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0434 7.1064H14.4121C14.1527 7.1064 13.9434 6.89624 13.9434 6.63765V4.33765C13.9434 4.07905 14.1527 3.8689 14.4121 3.8689H17.0434C17.302 3.8689 17.5121 4.07905 17.5121 4.33765V6.63765C17.5121 6.89624 17.302 7.1064 17.0434 7.1064ZM14.8809 6.1689H16.5746V4.8064H14.8809V6.1689Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337573240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.598 7.1064H18.9668C18.7074 7.1064 18.498 6.89624 18.498 6.63765V4.33765C18.498 4.07905 18.7074 3.8689 18.9668 3.8689H21.598C21.8566 3.8689 22.0668 4.07905 22.0668 4.33765V6.63765C22.0668 6.89624 21.8566 7.1064 21.598 7.1064ZM19.4355 6.1689H21.1293V4.8064H19.4355V6.1689Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337572712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2726 26.882H10.7273C10.4679 26.882 10.2585 26.6719 10.2585 26.4133V9.95703C10.2585 9.69766 10.4679 9.48828 10.7273 9.48828H30.2726C30.532 9.48828 30.7414 9.69766 30.7414 9.95703V26.4133C30.7414 26.6719 30.532 26.882 30.2726 26.882ZM11.196 25.9445H29.8039V10.4258H11.196V25.9445Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337573312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2726 24.2273H19.8664C19.6078 24.2273 19.3976 24.0171 19.3976 23.7585C19.3976 23.5 19.6078 23.2898 19.8664 23.2898H30.2726C30.532 23.2898 30.7414 23.5 30.7414 23.7585C30.7414 24.0171 30.532 24.2273 30.2726 24.2273ZM17.0351 24.2273H10.7273C10.4679 24.2273 10.2585 24.0171 10.2585 23.7585C10.2585 23.5 10.4679 23.2898 10.7273 23.2898H17.0351C17.2937 23.2898 17.5039 23.5 17.5039 23.7585C17.5039 24.0171 17.2937 24.2273 17.0351 24.2273Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337573192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2726 20.5117H10.7273C10.4679 20.5117 10.2585 20.3016 10.2585 20.043C10.2585 19.7844 10.4679 19.5742 10.7273 19.5742H30.2726C30.532 19.5742 30.7414 19.7844 30.7414 20.043C30.7414 20.3016 30.532 20.5117 30.2726 20.5117Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337572976"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2726 16.7954H15.7679C15.5093 16.7954 15.2992 16.586 15.2992 16.3267C15.2992 16.0681 15.5093 15.8579 15.7679 15.8579H30.2726C30.532 15.8579 30.7414 16.0681 30.7414 16.3267C30.7414 16.586 30.532 16.7954 30.2726 16.7954ZM12.9367 16.7954H10.7273C10.4679 16.7954 10.2585 16.586 10.2585 16.3267C10.2585 16.0681 10.4679 15.8579 10.7273 15.8579H12.9367C13.1953 15.8579 13.4054 16.0681 13.4054 16.3267C13.4054 16.586 13.1953 16.7954 12.9367 16.7954Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337572808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2726 13.0798H27.8375C27.5789 13.0798 27.3687 12.8705 27.3687 12.6111C27.3687 12.3525 27.5789 12.1423 27.8375 12.1423H30.2726C30.532 12.1423 30.7414 12.3525 30.7414 12.6111C30.7414 12.8705 30.532 13.0798 30.2726 13.0798ZM25.4578 13.0798H10.7273C10.4679 13.0798 10.2585 12.8705 10.2585 12.6111C10.2585 12.3525 10.4679 12.1423 10.7273 12.1423H25.4578C25.7164 12.1423 25.9265 12.3525 25.9265 12.6111C25.9265 12.8705 25.7164 13.0798 25.4578 13.0798Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337573168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3523 26.882C14.0937 26.882 13.8835 26.6719 13.8835 26.4133V17.743C13.8835 17.4836 14.0937 17.2742 14.3523 17.2742C14.6109 17.2742 14.821 17.4836 14.821 17.743V26.4133C14.821 26.6719 14.6109 26.882 14.3523 26.882ZM14.3523 15.3805C14.0937 15.3805 13.8835 15.1703 13.8835 14.9117V9.95703C13.8835 9.69766 14.0937 9.48828 14.3523 9.48828C14.6109 9.48828 14.821 9.69766 14.821 9.95703V14.9117C14.821 15.1703 14.6109 15.3805 14.3523 15.3805Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337572616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4512 26.8823C18.1926 26.8823 17.9824 26.6721 17.9824 26.4135V25.1745C17.9824 24.9159 18.1926 24.7057 18.4512 24.7057C18.7098 24.7057 18.9199 24.9159 18.9199 25.1745V26.4135C18.9199 26.6721 18.7098 26.8823 18.4512 26.8823ZM18.4512 22.812C18.1926 22.812 17.9824 22.6018 17.9824 22.3432V9.95728C17.9824 9.6979 18.1926 9.48853 18.4512 9.48853C18.7098 9.48853 18.9199 9.6979 18.9199 9.95728V22.3432C18.9199 22.6018 18.7098 22.812 18.4512 22.812Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337573120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5488 26.8823C22.2902 26.8823 22.0801 26.6721 22.0801 26.4135V9.95728C22.0801 9.6979 22.2902 9.48853 22.5488 9.48853C22.8074 9.48853 23.0176 9.6979 23.0176 9.95728V26.4135C23.0176 26.6721 22.8074 26.8823 22.5488 26.8823Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337573096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6477 26.882C26.3891 26.882 26.179 26.6719 26.179 26.4133V13.8008C26.179 13.5422 26.3891 13.332 26.6477 13.332C26.9063 13.332 27.1165 13.5422 27.1165 13.8008V26.4133C27.1165 26.6719 26.9063 26.882 26.6477 26.882ZM26.6477 11.8898C26.3891 11.8898 26.179 11.6805 26.179 11.4211V9.95703C26.179 9.69766 26.3891 9.48828 26.6477 9.48828C26.9063 9.48828 27.1165 9.69766 27.1165 9.95703V11.4211C27.1165 11.6805 26.9063 11.8898 26.6477 11.8898Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337573912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6476 14.2704C25.7328 14.2704 24.989 13.5258 24.989 12.611C24.989 11.6969 25.7328 10.9524 26.6476 10.9524C27.5625 10.9524 28.3062 11.6969 28.3062 12.611C28.3062 13.5258 27.5625 14.2704 26.6476 14.2704ZM26.6476 11.8899C26.25 11.8899 25.9265 12.2133 25.9265 12.611C25.9265 13.0086 26.25 13.3321 26.6476 13.3321C27.0453 13.3321 27.3687 13.0086 27.3687 12.611C27.3687 12.2133 27.0453 11.8899 26.6476 11.8899Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337574104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4508 25.643C17.4117 25.643 16.5664 24.7977 16.5664 23.7586C16.5664 22.7196 17.4117 21.8743 18.4508 21.8743C19.4898 21.8743 20.3352 22.7196 20.3352 23.7586C20.3352 24.7977 19.4898 25.643 18.4508 25.643ZM18.4508 22.8118C17.9289 22.8118 17.5039 23.2368 17.5039 23.7586C17.5039 24.2805 17.9289 24.7055 18.4508 24.7055C18.9727 24.7055 19.3977 24.2805 19.3977 23.7586C19.3977 23.2368 18.9727 22.8118 18.4508 22.8118Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_337573360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3524 18.2119C13.3133 18.2119 12.468 17.3666 12.468 16.3275C12.468 15.2884 13.3133 14.4431 14.3524 14.4431C15.3915 14.4431 16.2368 15.2884 16.2368 16.3275C16.2368 17.3666 15.3915 18.2119 14.3524 18.2119ZM14.3524 15.3806C13.8305 15.3806 13.4055 15.8048 13.4055 16.3275C13.4055 16.8494 13.8305 17.2744 14.3524 17.2744C14.8743 17.2744 15.2993 16.8494 15.2993 16.3275C15.2993 15.8048 14.8743 15.3806 14.3524 15.3806Z",
    fill: "#111111"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatmap);
export default __webpack_public_path__ + "static/media/heatmap.10dc01d0e7dd4007df332cd70091ae74.svg";
export { ForwardRef as ReactComponent };